<template>
  <v-container :class="['container', {shrink: showSidebar}]">
    <v-fade-transition mode="out-in">
      <!-- The messages to show when there is no content -->
      <v-messages v-if="!classification || !feature" key="messages" />
      <!-- The tabs with the content -->
      <v-tabs v-else v-model="model" centered color="transparent" grow key="tabs">
        <!-- A tab to show the already created rules -->
        <v-tab ripple>Reglas creadas</v-tab>
        <v-tab-item>
          <v-rules />
        </v-tab-item>
        <!-- A tab to show the matching items for the rule -->
        <v-tab ripple>Matching items</v-tab>
        <v-tab-item>
          <v-items />
        </v-tab-item>
      </v-tabs>
    </v-fade-transition>
  </v-container>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import VItems from "./Items";
import VMessages from "./Messages";
import VRules from "./Rules";

export default {
  components: {
    VItems,
    VMessages,
    VRules
  },
  computed: {
    ...mapState("featureRules", [
      "activeTab",
      "classification",
      "feature",
      "showSidebar"
    ]),
    model: {
      get() {
        return this.activeTab;
      },
      set(tab) {
        this.setActiveTab(tab);
      }
    }
  },
  methods: {
    ...mapMutations("featureRules", ["setActiveTab"])
  }
};
</script>

<style scoped>
.container {
  margin-top: 0;
  margin-left: 0;
  transition: all 0.3s;
}

.shrink {
  transition: all 0.3s;
  margin-left: 300px;
}
</style>